const workshops =
{
    title  : 'Atelier',
    titleX : 'Ateliers'
};

export default workshops ;
